import * as XLSX from 'xlsx';
import { DateTime } from 'luxon';

import { extractTextFromCell } from '../Exports/exports.helpers';

export const getWorkReportExportColumns = (columns = []) => (
  columns.filter((col) => col.dataIndex && (col.title || col.textTitle))
);

export const exportWorkReportToExcel = ({
  rows = [],
  columns = [],
  fileName,
}) => {
  const exportColumns = getWorkReportExportColumns(columns);
  const header = exportColumns.map((col) => extractTextFromCell(col.textTitle || col.title));
  const body = rows.map((row) => (
    exportColumns.map((col) => extractTextFromCell(row[col.dataIndex]))
  ));

  const workbook = XLSX.utils.book_new();
  const sheet = XLSX.utils.aoa_to_sheet([header, ...body]);
  XLSX.utils.book_append_sheet(workbook, sheet, 'Work Reports');

  const defaultName = `Work-Reports-${DateTime.local().toFormat('yyyy-MM-dd-HHmm')}.xlsx`;
  XLSX.writeFile(workbook, fileName || defaultName);
};
